export default __webpack_public_path__ + "static/media/library-white.13584752.svg";